/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/placeholder3': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
		data: '<path d="M11.25,11.83,3,8.36v7.73a1.69,1.69,0,0,0,1,1.52L11.19,21h.06Z"/><path d="M12,10.5l8.51-3.57A1.58,1.58,0,0,0,20,6.55L12.8,3.18a1.87,1.87,0,0,0-1.6,0L4,6.55a1.58,1.58,0,0,0-.51.38Z"/><path d="M12.75,11.83V21h.05L20,17.61a1.69,1.69,0,0,0,1-1.51V8.36Z"/>'
  }
})
